import { chartsAPI } from "../api/api";
import { InfractionConsolidated, InfractionRanking, InfractionRankingFilter, InfractionSummarized } from "../store/types/infraction";
import { removeEmptyProperties } from "../utils/functions/functions";
import { handleServiceError } from "./handleServiceError";

export interface CheckMacroBody {
  user: string;
  vehicle: string;
  journey_event: string;
  started_at: string | null;
}

const infractionService = {
  getInfractionRanking: async (
    {
      filters,
      limit,
      offset,
    }: {
      filters: InfractionRankingFilter;
      limit: number;
      offset: number;
    },
    section?: string
  ) => {
    try {
      const response = await chartsAPI.get(`/v1/infraction/ranking`, {
        params: { 
          ...removeEmptyProperties({
            ...filters,
            infraction_types: filters.infraction_types?.join(",")
          }), 
          limit, 
          offset 
        },
        headers: { section }
      });
      const data: InfractionRanking[] = response.data.data;
      const totalItems = Number(response.headers["x-total-count"]);

      return { data, totalItems };
    } catch (error) {
      handleServiceError(error);
    }
  },
  getInfractionConsolidated: async (
    userId: string,
    referenceDay: string | null,
    referenceMonth: string | null,
  ) => {
    try {
      const response = await chartsAPI.get(`/v1/infraction/consolidated/user/${userId}`, {
        params: { 
          ...(referenceDay ) && { reference_day: referenceDay },
          ...(referenceMonth ) && { reference_month: referenceMonth }
        },
      });
      const data: InfractionConsolidated = response.data.data;

      return data;
    } catch (error) {
      handleServiceError(error);
    }
  },
  getInfractionSummarized: async (
    referenceDay: string | null,
    referenceMonth?: string | null,
    section?: string
  ) => {
    try {
      const response = await chartsAPI.get(`/v1/infraction/summarized`, {
        params: { 
          ...(referenceMonth) && { reference_month: referenceMonth },
          ...(referenceDay) && { reference_day: referenceDay }
        },
        headers: { section }
      });
      const data: InfractionSummarized = response.data.data;

      return data;
    } catch (error) {
      handleServiceError(error);
    }
  },
  getInfractionTypePerPeriodChartData: async (
    startDate: string,
    endDate: string,
    granularity: string,
    referenceMonth?: string,
    userId?: string,
    section?: string
  ) => {
    try {
      const response = await chartsAPI.get(`/v1/infraction/typeperperiod`, {
        params: { 
          ...(!referenceMonth && startDate) && { start_date: startDate },
          ...(!referenceMonth && endDate) && { end_date: endDate },
          ...(referenceMonth) && { reference_month: referenceMonth },
          ...(granularity) && { granularity },
          ...(userId) && { user_id: userId },
        },
        headers: { section }
      });
      return response.data.data;
    } catch (error) {
      handleServiceError(error);
    }
  },
};

export default infractionService;
